import { render } from "./IconInCircle.vue?vue&type=template&id=72c581ab&scoped=true"
import script from "./IconInCircle.vue?vue&type=script&lang=js"
export * from "./IconInCircle.vue?vue&type=script&lang=js"

import "./IconInCircle.vue?vue&type=style&index=0&id=72c581ab&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c581ab"]])

export default __exports__